import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    root: {
      padding: 0,
      marginTop: theme.spacing(1),
    },
    totalBalance: {
      fontWeight: theme.typography.fontWeightBold,
    },
    poolBalance: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: theme.spacing(0.5),
      fontSize: '0.875rem',
      paddingLeft: 0,
      paddingRight: 0,
      padding: 0,
    },
    poolName: {
      overflow: 'hidden',
    },
    poolValue: {},
    divider: {
      fontSize: '0.75rem',
      color: theme.palette.text.secondary,
    },
  };
};
